import React from 'react';
import { useOrientations } from "@common/hooks/useOrientation";
import styles from "./SecondLogo.module.scss";

export const SecondLogo = () => {
  const orientation = useOrientations();

  return (
    <picture>
      <source
        srcSet='/images/footer-second-logo.svg'
        media='(min-width: 768px)'
      />
      <source
        srcSet='/images/footer-second-logo-mobile.svg'
        media='(max-width: 767px)'
      />
      <img
        className={styles.img}
        srcSet={`'/images/${orientation !== "mobile" ? 'footer-second-logo' : 'footer-second-logo-mobile'}.svg`}
        alt="second logo"
      />
    </picture>
  );
};
